import { Skeleton } from "src/atoms/Skeleton";
import { Box, Flex } from "@otrium/core";
import { Container } from "src/atoms/Container";
import { ProductCardSkeleton } from "src/molecules/ProductCardSkeleton";

const CardsRowSkeleton = () => (
  <Flex mx={-2}>
    {[...(Array(4) as number[])].map((_value, index) => (
      <Box key={index} px={2} py={2} width={1 / 4}>
        <ProductCardSkeleton />
      </Box>
    ))}
  </Flex>
);

const CollectionsViewSkeleton = (): JSX.Element => (
  <Container>
    <Flex flexWrap="wrap" mt={2}>
      <Box width={"200px"} height="20px">
        <Skeleton />
      </Box>
      <Box width={"45px"} height="20px">
        <Skeleton />
      </Box>
      <Box width={"45px"} height="20px">
        <Skeleton />
      </Box>
    </Flex>
    <Flex mt={2} width={"150px"} height="35px">
      <Skeleton />
    </Flex>
    <Flex flexWrap="wrap" mx={-2}>
      <Box width="100%">
        <CardsRowSkeleton />
        <CardsRowSkeleton />
      </Box>
    </Flex>
  </Container>
);

export default CollectionsViewSkeleton;
